var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteClipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3696 0.638911C12.9752 0.244524 12.3381 0.244524 11.9437 0.638911L6.9987 5.57381L2.05369 0.628798C1.6593 0.234411 1.02221 0.234411 0.627822 0.628798C0.233434 1.02319 0.233434 1.66027 0.627822 2.05466L5.57284 6.99968L0.627822 11.9447C0.233434 12.3391 0.233434 12.9762 0.627822 13.3706C1.02221 13.7649 1.6593 13.7649 2.05369 13.3706L6.9987 8.42554L11.9437 13.3706C12.3381 13.7649 12.9752 13.7649 13.3696 13.3706C13.764 12.9762 13.764 12.3391 13.3696 11.9447L8.42456 6.99968L13.3696 2.05466C13.7538 1.67039 13.7538 1.02319 13.3696 0.638911Z",
    fill: "#252527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteClipping);
export default __webpack_public_path__ + "static/media/delete-clipping.9f46c439c63fc424326cd8456f86d2a8.svg";
export { ForwardRef as ReactComponent };